const template = `
    <article class="welcome">
        <md-content>
            <h1 class="md-display-2 section-title">Welcome!</h1>

            <installation-breadcrumbs></installation-breadcrumbs>

            <div ng-if="installation.loggedIn" layout="row" layout-align="center">
            <br>
                <md-button ng-click="getStarted($event)"
                           class="md-primary md-raised">
                    Let's get started
                </md-button>
            </div>

            <div ng-if="!installation.loggedIn">
                <form name="tokenForm"
                      ng-if="!installation.hasAdminUser"
                      ng-submit="validateToken($event)">
                    <md-card>
                        <md-card-content>
                            <app-input-text name="token"
                                            value="token.value"
                                            form="tokenForm"
                                            label="Token"
                                            required>
                            </app-input-text>
                        </md-card-content>

                        <md-card-actions layout="row" layout-align="end">
                            <md-button type="submit"
                                       class="md-primary md-raised"
                                       ng-disabled="tokenForm.$invalid">
                                Let's get started
                            </md-button>
                        </md-card-actions>
                    </md-card>
                </form>

                <form method="POST"
                      ng-if="installation.hasAdminUser"
                      name="loginForm"
                      autocomplete="off"
                      ng-submit="login($event)">
                    <md-card>
                        <md-card-content layout="column">

                            <app-input-email
                                name="email"
                                value="user.email"
                                form="loginForm"
                                label="Email Address"
                                required>
                            </app-input-email>

                            <app-input-password
                                name="password"
                                value="user.password"
                                form="loginForm"
                                label="Password"
                                required>
                            </app-input-password>
                        </md-card-content>

                        <md-card-actions layout="row" layout-align="end center">
                            <md-button type="submit" class="md-primary md-raised">
                                Login
                            </md-button>
                        </md-card-actions>
                    </md-card>
                </form>
            </div>

        </md-content>
    </article>
`;

WelcomeController.$inject = ['$app', '$http', '$installation', '$scope', '$state'];

function WelcomeController($app, $http, $installation, $scope, $state) {
    $scope.installation = $installation;
    $scope.token = {
        value: null,
    };
    $scope.user = {
        email: null,
        password: null,
    };

    console.log($installation.nextStep);

    // Main
    if ($installation.nextStep === 'finish' && !$installation.editing) {
        $state.go($installation.nextStep);
        return;
    }

    $scope.getStarted = function getStarted() {
        console.log($installation.nextStep);
        $state.go($installation.nextStep);
    };

    $scope.login = function login($event) {
        $event.preventDefault();

        $http.post('/auth/login', $scope.user).then(
            () => {
                $installation.loggedIn = true;
                $state.go($installation.nextStep);
            },
            error => {
                $app.errorToast(error.data.message);
                $scope.user.password = null;
            },
        );
    };

    $scope.validateToken = function validateToken() {
        $http
            .post('/install/validate-token', {
                token: $scope.token.value,
            })
            .then(
                response => {
                    const data = response.data;

                    if (data.valid) {
                        $installation.token = data.token;

                        // Go to the next step
                        $state.go($installation.nextStep);
                    } else {
                        $app.errorToast(data.message);
                    }
                },
                response => {
                    const data = response.data;

                    $app.errorToast(data.message);

                    console.error(response);
                },
            );
    };
}

export { template, WelcomeController as controller };
